
import Vue from 'vue';

Vue.directive('scroll');




// WEBPACK FOOTER //
// ./src/directives/global.js